import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {TicketPrice} from '../../../../../../projects/shared-lib/src/lib/models/ticket-price';
import { ClientTicketLineComponent } from '../client-ticket-line/client-ticket-line.component';

@Component({
    selector: 'tw-ticket-details',
    templateUrl: './client-ticket-details.component.html',
    styleUrls: ['./client-ticket-details.component.css'],
    imports: [ClientTicketLineComponent]
})
export class ClientTicketDetailsComponent implements OnInit {
    @Input() ticketPrices: TicketPrice[];
    @Output() displayPdf: EventEmitter<string> = new EventEmitter<string>();

    constructor() {
    }

    ngOnInit() {
    }

    displayPdfFile(url: string) {
        this.displayPdf.emit(url);
    }

}
